import * as React from "react";
import { Link } from "react-router-dom";
import {cx} from "emotion";

import "./edition-card.scss";

import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {keyed}             from "@Common/react/keyed";
import {Load2}             from "@Common/react/load2";
import {UseState}          from "@Common/react/use-state";
import {Badge}             from "@Common/ui-components/heavy/common/design2/badge/badge";
import {InformationBadge}  from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {ImageGalleryModal} from "@Common/ui-components/image-gallery-modal/image-gallery-modal";
import {formatMoney1}      from "@Common/ui-components/language/format-money";
import {chain}             from "@Common/utils/fs";

import {XdLogo1Svg} from "./xd-logo-1-svg";

export const EditionCard = (
    {
        templateId,
        amount=undefined,
        imgs=undefined,
        name,
        templateName,
        details,
        proofLink=undefined,
        badge=null,
        errorMessage=undefined,
        deleting=undefined,
    }
) => cs(
    consumeContext("proofImgsCache"),
    ["proofImgsCache1", ({proofImgsCache}, next) => next(proofImgsCache(templateId))],
    ["imageGalleryModal", (_, next) => ImageGalleryModal({next})],
    ({imageGalleryModal, proofImgsCache1}) => (
        <div {...{
            className: "edition-card-5fm",
            "xd-qa-type": "card",
            "xd-qa-name": "Edition " + name,
        }}>
            <div {...{
                className: "thumbnail",
                onClick: () => imageGalleryModal.show({
                    renderImgs: (next) => cs(
                        ["data", ({}, next) => Load2({
                            fetch: () => proofImgsCache1.load(),
                            next,
                        })],
                        ({data}) => next({
                            loading: data.loading,
                            value: imgs,
                            ...!data.loading && {
                                value: data.value.jpg.map((url) => ({enlarged: url})),
                            },
                        }),
                    ),
                }),
            }}>
                {imgs?.length ? <>
                    {imgs[0].loading ? (
                        <div className="img-loading">
                            <i className="fa fa-spinner fa-pulse"/>
                        </div>
                    ) : (
                        <img {...{
                            src: proofImgsCache1.getLoaded()?.jpg[0] ?? chain(
                                imgs[0],
                                (_) => _?.thumbnail ?? _?.enlarged,
                            ),
                            "xd-qa-type": "image",
                            "xd-qa-name": "Thumbnail",
                        }}/>
                    )}


                    <div {...{
                        className: "preview",
                        "xd-qa-type": "button",
                        "xd-qa-name": "Preview image",
                    }}>
                        <div className="icon">
                            <i className="fa fa-search"/>
                        </div>

                        <div className="text">
                            Proof Preview
                        </div>
                    </div>

                </> : (
                    <div className="no-img">
                        {XdLogo1Svg()}
                    </div>
                )}
            </div>

            <div className="info">
                <div className="top">
                    <div className="left">
                        <div {...{
                            className: "name",

                            "xd-qa-type": "label",
                            "xd-qa-name": "Edition name",
                        }}>
                            {name}
                        </div>
                        {!!templateName && (
                            <div {...{
                                className: "template-name",

                                "xd-qa-type": "label",
                                "xd-qa-name": "Template name",
                            }}>
                                {templateName}
                            </div>
                        )}
                    </div>

                    <div className="right">
                        {amount && (
                            amount.loading ? (
                                <i className="fa fa-spinner fa-pulse"/>
                            ) : <>
                                {/*<div {...{*/}
                                {/*    className: "label",*/}

                                {/*    "xd-qa-type": "label",*/}
                                {/*    "xd-qa-name": "Amount explanation",*/}
                                {/*}}>*/}
                                {/*    {amount.label}*/}
                                {/*</div>*/}
                                {!!amount.tooltip && InformationBadge({
                                    getTooltip: () => amount.tooltip,
                                    direction: "west",
                                })}
                                <div {...{
                                    className: "value",

                                    "xd-qa-type": "text",
                                    "xd-qa-name": "Amount",
                                }}>
                                    {amount.value != null ? (
                                        formatMoney1(amount.value)
                                    ) : (
                                        "$-.-"
                                    )}
                                </div>
                            </>
                        )}
                        {deleting && cs(
                            ["deletingState", (_, next) => UseState({next})],
                            ({deletingState}) => (
                                <i {...{
                                    onClick: async () => {
                                        if (deletingState.value) {
                                            return;
                                        }
                                        if (await deleting.confirm()) {
                                            deletingState.onChange(true);
                                            await deleting.onDelete();
                                            deletingState.onChange(false);
                                        }
                                    },
                                    className: cx(
                                        "fa",
                                        deletingState.value ? "fa-spinner fa-pulse" : "fa-trash",
                                        {deleting: deletingState.value},
                                    ),

                                    "xd-qa-type": "button",
                                    "xd-qa-name": "Remove Edition",
                                }}/>
                            ),
                        )}
                    </div>
                </div>

                <div className="line2">
                    {badge && Badge({...badge,})}

                    {errorMessage && (
                        <div {...{
                            className: "error-message",

                            "xd-qa-type": "text",
                            "xd-qa-name": "Error message",
                        }}>
                            {errorMessage}
                        </div>
                    )}
                </div>

                <div className="details-train">
                    {details.map(({label, value, tooltip}) => cs(
                        keyed(label),
                        () => (
                            <div className="car" title={tooltip}>
                                <div {...{
                                    className: "label",
                                    "xd-qa-type": "label",
                                    "xd-qa-name": label,
                                }}>
                                    {label}
                                </div>
                                <div {...{
                                    className: "value",
                                    "xd-qa-type": "text",
                                    "xd-qa-name": label,
                                }}>
                                    {value}
                                </div>
                            </div>
                        )
                    ))}
                </div>
                {proofLink && (
                    <div className="action">
                        <Link {...{
                            to: proofLink,

                            "xd-qa-type": "button",
                            "xd-qa-name": "PROOF & EDIT",
                        }}>
                            PROOF & EDIT
                        </Link>
                    </div>
                )}

            </div>
        </div>
    )
);

